import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import { cn } from './cn';

/**
 * Token surface primitive (PRO-0260, DS-9/DS-10). Polymorphic via `as` so a Home
 * launchpad tile can render as a single focusable `Link`/`a` (SF-002) — keeping one
 * interactive target per card — while a static panel stays a `div`. Token radius /
 * shadow / border; keyboard focus is the global token ring.
 */
const cardBase = 'block rounded-lg border border-border bg-surface shadow-sm';

export type CardProps<T extends ElementType = 'div'> = {
  as?: T;
  className?: string;
  children: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'className' | 'children'>;

export function Card<T extends ElementType = 'div'>({ as, className, children, ...rest }: CardProps<T>) {
  const Component = (as ?? 'div') as ElementType;
  return (
    <Component className={cn(cardBase, className)} {...rest}>
      {children}
    </Component>
  );
}
